export enum SourceSystem {
  Base = 'Base',
  NOLS = 'Nols',
  SAP = 'SAP'
}